import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const handlers = new WeakMap()
const items = new WeakMap()
const wrappers = new WeakSet()

const onInput = object(listener, {
  type: input,
  task: async element => {
    const item = items.get(element)
    const delay = one('[name="new_reminder[delay][]"]', item)
    const quantity = one('[name="_reminder_delay_time"]', item)
    const unit = one('[name="_reminder_delay_unit"]', item)

    await handlers.get(element)?.(quantity, unit, delay)
  }
})

export const handle = (element, handler) => {
  const item = closest(`[data-contract*="event.addEdit.reminder.wrapper"]`, element)

  if (!wrappers.has(item)) {
    return
  }

  handlers.set(element, handler)
  items.set(element, item)
  onInput.listen(element)

  queueMicrotask(async () => {
    await removed(element)
    handlers.delete(element)
    items.delete(element)
  })
}

export default wrapper => {
  wrappers.add(wrapper)

  queueMicrotask(async () => {
    await removed(wrapper)
    wrappers.delete(wrapper)
  })
}
